
export const test_url = 'http://127.0.0.1:8000/';
export const test_url_images = 'http://127.0.0.1:8000';
